module.exports = __webpack_public_path__ + "media/images/quote-8a9180cac50c0b9510c11ab9ebf10a8a.png";